import HTTP from "@/_helpers/http";
import { STATES__API } from "@/_helpers/urls";
import { STATES__MUTATIONS } from "../mutation-types";
import { STATES__ACTIONS } from "../action-types";

// State
const state = {
  states: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [STATES__MUTATIONS.STATES](state, data) {
    state.states = data;
  },
};
// Actions
const actions = {
  async [STATES__ACTIONS.STATES]({ commit, state }, id) {
    try {
      const url = `${STATES__API.STATES}/${id}`;
      const response = await HTTP().get(url);

      if (response.status === 200) {
        commit(STATES__MUTATIONS.STATES, response.data);
      } else {
        commit(STATES__MUTATIONS.STATES, []);
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
